import React from 'react';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { FormGroup, ButtonContainer, SubmitButton } from '../../../form';
import { InputText } from '../../../formikBindings';
import SectionList from './sections';
import { IQuestionnaireFormProps, IQuestionnaireFormValues } from './types';

const QuestionnaireForm: React.FC<IQuestionnaireFormProps> = ({ onDelete }) => {
  const { values } = useFormikContext<IQuestionnaireFormValues>();

  return (
    <>
      <FormGroup name="name" label="Name" required>
        <InputText name="name" maxLength={255} autoFocus />
      </FormGroup>
      <SectionList sections={values.sections} />
      <ButtonContainer>
        {onDelete && (
          <Button variant="danger" onClick={onDelete}>
            Delete
          </Button>
        )}
        <SubmitButton>Save</SubmitButton>
      </ButtonContainer>
    </>
  );
};

export default QuestionnaireForm;
